import RailsResource from './rails-resource';

export default new class GuardianService extends RailsResource {
  constructor() {
    super({
      url: '/admin',
      resource: 'guardians',
      ajaxLoader: false
    });
  }

  byEmail(email) {
    return this.call(`${this.url}/${this.resource}/email/${email}`);
  }

  // PATCH to-student
  toStudent(guardianId) {
    return this.patch(`${this.url}/${this.resource}/${guardianId}/to-student.json`, true)
  }

  addDependent(guardianId, {enrollmentId, kinshipDegreeId}) {
    return this.post(`${this.url}/${this.resource}/${guardianId}/dependent.json`, true, {
      enrollment_id: enrollmentId,
      kinship_degree_id: kinshipDegreeId
    })
  }
};